import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Los campos los pinta el formulario hijo; aquí solo se unifican sus etiquetas
export const Body = styled.div`
  font-family: ${tokens.typography.fontFamily.primary};

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${tokens.color.text.label};
  }
`
